import React from 'react';
import { VideoPlugin } from './VideoPlugin';
import styled from 'styled-components';

import { IPropsVideo } from '../../common-types/Prop';

export const VideoContainer = styled.div`
  margin-top: 0;
  position: relative;
  display: inline-block;
  width: 96vw;
  overflow: hidden;
  height: 96vh;
  border-radius: 3vw;
`;
VideoContainer.displayName = 'VideoContainer';

export const CustomVideoPlugin: React.FunctionComponent<IPropsVideo> = (props) => (
  <VideoPlugin
    {...props}
    VideoWrapper={VideoContainer}
  />
);